import * as apiUtils from "@/utils/apiUtils"

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {},
  // -----------------------------------------------------------------
  getters: {},
  // -----------------------------------------------------------------
  mutations: {},
  // -----------------------------------------------------------------
  actions: {
    // Customers
    getCustomer: (context, tid) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/customers/" + tid
      return apiUtils.get(path)
    },
    getCustomers: (context, query) => {
      // , { pageNumber, pageSize }
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/customers"
      return apiUtils.get(path, query)
    },
    createCustomer: (
      context,
      {
        name,
        email,
        phone,
        accountNumber,
        bankSwiftCode,
        bankName,
        bankAddress,
        fax,
        mobile,
        website,
        taxId,
        memo,
        billingPostalCode,
        billingAddress,
        billingAddress2,
        billingCurrencyCode,
        billingCountryCode,
        shippingCountryCode,
        shippingPostalCode,
        shippingAddress,
        shippingAddress2,
        shippingRecipient,
        shippingMemo,
        relatedBusinessId
      }
    ) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/customers"
      return apiUtils.post(path, {
        name,
        email,
        phone,
        accountNumber,
        bankSwiftCode,
        bankName,
        bankAddress,
        fax,
        mobile,
        website,
        taxId,
        memo,
        billingPostalCode,
        billingAddress,
        billingAddress2,
        billingCurrencyCode,
        billingCountryCode,
        shippingCountryCode,
        shippingPostalCode,
        shippingAddress,
        shippingAddress2,
        shippingRecipient,
        shippingMemo,
        relatedBusinessId
      })
    },
    updateCustomer: (
      context,
      {
        id,
        name,
        email,
        phone,
        accountNumber,
        bankSwiftCode,
        bankName,
        bankAddress,
        fax,
        mobile,
        website,
        taxId,
        memo,
        billingPostalCode,
        billingAddress,
        billingAddress2,
        billingCurrencyCode,
        billingCountryCode,
        shippingCountryCode,
        shippingPostalCode,
        shippingAddress,
        shippingAddress2,
        shippingRecipient,
        shippingMemo
      }
    ) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/customers/" + id
      return apiUtils.patch(path, {
        name,
        email,
        phone,
        accountNumber,
        bankSwiftCode,
        bankName,
        bankAddress,
        fax,
        mobile,
        website,
        taxId,
        memo,
        billingPostalCode,
        billingAddress,
        billingAddress2,
        billingCurrencyCode,
        billingCountryCode,
        shippingCountryCode,
        shippingPostalCode,
        shippingAddress,
        shippingAddress2,
        shippingRecipient,
        shippingMemo
      })
    },
    deleteCustomer: (context, id) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/customers/" + id
      return apiUtils.delete(path)
    }
  }
}
